function statesConfig(
    $stateProvider,
    $urlRouterProvider,
    $locationProvider,
    $httpProvider,
    config
) {
    $urlRouterProvider.otherwise(window.location.href.indexOf('https://registry.azure.hycu.com/') !== -1 ? '/signup' : '/login');
    $urlRouterProvider.when("/app", "/app/dashboard");
    //STATES FOR DEVELOPMENT
    if (window.location.href.indexOf('https://registry.azure.hycu.com/') !== -1) {
        $stateProvider
            .state("gcbackup", {
                url: "",
                views: {
                    main: {
                        controller: [
                            "$location",
                            "$state",
                            "storageService",
                            function ($location, $state, storageService) {
                                var url = $location.absUrl();
                                var arr = url.split('?');
                                if (url.length > 1 && arr[1]) {
                                    let paramsArray = arr[1].split("&");
                                    let params = {};
                                    paramsArray.forEach(element => {
                                        let temp = element.split("=");
                                        params[temp[0]] = temp[1];
                                    });

                                    if (params.state) {
                                        $state.go('registration', { stateObject: params });
                                    }
                                    else {
                                        $state.go('registration', { loginObj: params });
                                    }
                                } else {
                                    $state.go(
                                        storageService.getToken() ? "registration" : "registration"
                                    );
                                }
                            }
                        ]
                    }
                }
            })
            .state('registration', {
                url: '/signup',
                params: {
                    stateObject: null
                },
                views: {
                    'main': {
                        template: '<registration></registration>'
                    },
                },
                resolve: {
                    translations: ['translateService', translateService => translateService.translationsPromise],
                    modal: ['$document', $document => $document.find('.modal-backdrop').remove()]
                }
            })
        //STATES FOR PROXY
    } else if (window.location.href.indexOf('https://endpoints.azure.hycu.com/') !== -1) {
        $stateProvider
            .state("gcbackup", {
                url: "",
                views: {
                    main: {
                        controller: [
                            "$location",
                            "$state",
                            "storageService",
                            function ($location, $state, storageService) {
                                var url = $location.absUrl();
                                var arr = url.split('?');
                                if (url.length > 1 && arr[1]) {
                                    let paramsArray = arr[1].split("&");
                                    let params = {};
                                    paramsArray.forEach(element => {
                                        let temp = element.split("=");
                                        params[temp[0]] = temp[1];
                                    });

                                    if (params.state) {
                                        $state.go('login', { stateObject: params });
                                    }
                                    else {
                                        $state.go('login', { loginObj: params });
                                    }
                                } else {
                                    $state.go(
                                        storageService.getToken() ? "app.dashboard" : "login"
                                    );
                                }
                            }
                        ]
                    }
                }
            })
            .state("login", {
                url: "/login",
                params: {
                    loginObj: null
                },
                views: {
                    main: {
                        template: "<login></login>"
                    }
                },
                resolve: {
                    translations: [
                        "translateService",
                        translateService => translateService.translationsPromise
                    ],
                    modal: [
                        "$document",
                        $document => $document.find(".modal-backdrop").remove()
                    ]
                }
            })
            .state("authorizeToken", {
                url: "/authorizeToken",
                views: {
                    main: {
                        template: "<authorize-token></authorize-token>"
                    }
                },
                resolve: {
                    translations: [
                        "translateService",
                        translateService => translateService.translationsPromise
                    ],
                    modal: [
                        "$document",
                        $document => $document.find(".modal-backdrop").remove()
                    ]
                }
            })
            .state("app", {
                url: "/app",
                abstract: true,
                views: {
                    main: { template: "<main-app></main-app>" }
                },
                data: {
                    roles: ["Built-in Administrator", "Administrator", "Tenant"],
                    docs: ""
                },
                resolve: {
                    translations: [
                        "translateService",
                        translateService => translateService.translationsPromise
                    ],
                    authorize: [
                        "authorizationService",
                        authorizationService => authorizationService.authorize()
                    ]
                }
            })
            .state("app.dashboard", {
                parent: "app",
                url: "/dashboard?isLogin",
                data: {
                    roles: ["Built-in Administrator", "Administrator", "Tenant"],
                    docs: "dashboard"
                },
                views: {
                    app: {
                        template: "<dashboard></dashboard>"
                    }
                }
            })
            .state("app.accessdenied", {
                parent: "app",
                url: "/accessdenied",
                data: {
                    roles: []
                },
                views: {
                    app: {
                        template: "<access-denied></access-denied>"
                    }
                }
            })
            .state("app.virtualmachines", {
                parent: "app",
                url: "/virtual-machines?protectionFilter&compliantFilter&policyFilter",
                data: {
                    roles: ["Built-in Administrator", "Administrator", "Tenant"],
                    docs: "virtual-machines"
                },
                views: {
                    app: {
                        template:
                            '<virtual-machines sort-criteria="vmName" num-of-show-vms="10" starting-page="1"></virtual-machines>'
                    }
                }
            })
            // .state('app.apps', {
            //   parent: 'app',
            //   url: '/apps?protectionFilter&compliantFilter&policyFilter',
            //   data: {
            //     roles: ['Built-in Administrator', 'Administrator', 'Tenant'],
            //     docs: 'applications'
            //   },
            //   views: {
            //     'app': {
            //       template: '<apps></apps>',
            //     }
            //   },
            // })
            .state("app.jobs", {
                parent: "app",
                url: "/tasks?statusFilter&nameFilter&jobUuid",
                data: {
                    roles: ["Built-in Administrator", "Administrator", "Tenant"],
                    docs: "tasks"
                },
                views: {
                    app: {
                        template: "<jobs></jobs>"
                    }
                },
                resolve: {
                    modal: [
                        "$document",
                        $document => $document.find(".modal-backdrop").remove()
                    ]
                }
            })
            .state("app.events", {
                parent: "app",
                url: "/events?statusFilter?eventUuid",
                data: {
                    roles: ["Built-in Administrator", "Administrator", "Tenant"],
                    docs: "events"
                },
                views: {
                    app: {
                        template: "<events></events>"
                    }
                },
                resolve: {
                    modal: [
                        "$document",
                        $document => $document.find(".modal-backdrop").remove()
                    ]
                }
            })
            .state("app.policies", {
                parent: "app",
                url: "/policies?statusFilter&compliantFilter",
                data: {
                    roles: ["Built-in Administrator", "Administrator", "Tenant"],
                    docs: "policies"
                },
                views: {
                    app: {
                        template:
                            '<policies sort-criteria="name" num-of-show-pgs="10" starting-page="1"></pgs>'
                    }
                }
            }).state('app.reports', {
                parent: 'app',
                url: '/reports',
                data: {
                    docs: 'reports'
                },
                views: {
                    'app': {
                        template: '<reports></reports>'
                    }
                }
            })
            // .state('app.users', {
            //   parent: 'app',
            //   url: '/users',
            //   data: {
            //     roles: ['Built-in Administrator', 'Administrator'],
            //     docs: 'selfservice'
            //   },
            //   views: {
            //     'app': {
            //       template: '<users></users>'
            //     }
            //   },
            // })cons
            .state("app.targets", {
                parent: "app",
                url: "/targets",
                data: {
                    roles: ["Built-in Administrator", "Administrator"],
                    docs: "targets"
                },
                views: {
                    app: {
                        template: "<targets></targets>"
                    }
                }
            });
    }

    else {
        $stateProvider
            .state("gcbackup", {
                url: "",
                views: {
                    main: {
                        controller: [
                            "$location",
                            "$state",
                            "storageService",
                            function ($location, $state, storageService) {
                                var url = $location.absUrl();
                                var arr = url.split('?');
                                if (url.length > 1 && arr[1]) {
                                    let paramsArray = arr[1].split("&");
                                    let params = {};
                                    paramsArray.forEach(element => {
                                        let temp = element.split("=");
                                        params[temp[0]] = temp[1];
                                    });

                                    if (params.state) {
                                        $state.go('registration', { stateObject: params });
                                    }
                                    else {
                                        $state.go('login', { loginObj: params });
                                    }
                                } else {
                                    $state.go(
                                        storageService.getToken() ? "app.dashboard" : "login"
                                    );
                                }
                            }
                        ]
                    }
                }
            })
            .state("login", {
                url: "/login",
                params: {
                    loginObj: null
                },
                views: {
                    main: {
                        template: "<login></login>"
                    }
                },
                resolve: {
                    translations: [
                        "translateService",
                        translateService => translateService.translationsPromise
                    ],
                    modal: [
                        "$document",
                        $document => $document.find(".modal-backdrop").remove()
                    ]
                }
            })
            .state('registration', {
                url: '/signup',
                params: {
                    stateObject: null
                },
                views: {
                    'main': {
                        template: '<registration></registration>'
                    },
                },
                resolve: {
                    translations: ['translateService', translateService => translateService.translationsPromise],
                    modal: ['$document', $document => $document.find('.modal-backdrop').remove()]
                }
            })
            .state("authorizeToken", {
                url: "/authorizeToken",
                views: {
                    main: {
                        template: "<authorize-token></authorize-token>"
                    }
                },
                resolve: {
                    translations: [
                        "translateService",
                        translateService => translateService.translationsPromise
                    ],
                    modal: [
                        "$document",
                        $document => $document.find(".modal-backdrop").remove()
                    ]
                }
            })
            .state("app", {
                url: "/app",
                abstract: true,
                views: {
                    main: { template: "<main-app></main-app>" }
                },
                data: {
                    roles: ["Built-in Administrator", "Administrator", "Tenant"],
                    docs: ""
                },
                resolve: {
                    translations: [
                        "translateService",
                        translateService => translateService.translationsPromise
                    ],
                    authorize: [
                        "authorizationService",
                        authorizationService => authorizationService.authorize()
                    ]
                }
            })
            .state("app.dashboard", {
                parent: "app",
                url: "/dashboard?isLogin",
                data: {
                    roles: ["Built-in Administrator", "Administrator", "Tenant"],
                    docs: "dashboard"
                },
                views: {
                    app: {
                        template: "<dashboard></dashboard>"
                    }
                }
            })
            .state("app.accessdenied", {
                parent: "app",
                url: "/accessdenied",
                data: {
                    roles: []
                },
                views: {
                    app: {
                        template: "<access-denied></access-denied>"
                    }
                }
            })
            .state("app.virtualmachines", {
                parent: "app",
                url: "/virtual-machines?protectionFilter&compliantFilter&policyFilter",
                data: {
                    roles: ["Built-in Administrator", "Administrator", "Tenant"],
                    docs: "virtual-machines"
                },
                views: {
                    app: {
                        template:
                            '<virtual-machines sort-criteria="vmName" num-of-show-vms="10" starting-page="1"></virtual-machines>'
                    }
                }
            })
            // .state('app.apps', {
            //   parent: 'app',
            //   url: '/apps?protectionFilter&compliantFilter&policyFilter',
            //   data: {
            //     roles: ['Built-in Administrator', 'Administrator', 'Tenant'],
            //     docs: 'applications'
            //   },
            //   views: {
            //     'app': {
            //       template: '<apps></apps>',
            //     }
            //   },
            // })
            .state('app.reports', {
                parent: 'app',
                url: '/reports',
                data: {
                    docs: 'reports'
                },
                views: {
                    'app': {
                        template: '<reports></reports>'
                    }
                }
            })
            .state("app.jobs", {
                parent: "app",
                url: "/tasks?statusFilter&nameFilter&jobUuid",
                data: {
                    roles: ["Built-in Administrator", "Administrator", "Tenant"],
                    docs: "tasks"
                },
                views: {
                    app: {
                        template: "<jobs></jobs>"
                    }
                },
                resolve: {
                    modal: [
                        "$document",
                        $document => $document.find(".modal-backdrop").remove()
                    ]
                }
            })
            .state("app.events", {
                parent: "app",
                url: "/events?statusFilter?eventUuid",
                data: {
                    roles: ["Built-in Administrator", "Administrator", "Tenant"],
                    docs: "events"
                },
                views: {
                    app: {
                        template: "<events></events>"
                    }
                },
                resolve: {
                    modal: [
                        "$document",
                        $document => $document.find(".modal-backdrop").remove()
                    ]
                }
            })
            .state("app.policies", {
                parent: "app",
                url: "/policies?statusFilter&compliantFilter",
                data: {
                    roles: ["Built-in Administrator", "Administrator", "Tenant"],
                    docs: "policies"
                },
                views: {
                    app: {
                        template:
                            '<policies sort-criteria="name" num-of-show-pgs="10" starting-page="1"></pgs>'
                    }
                }
            })
            // .state('app.users', {
            //   parent: 'app',
            //   url: '/users',
            //   data: {
            //     roles: ['Built-in Administrator', 'Administrator'],
            //     docs: 'selfservice'
            //   },
            //   views: {
            //     'app': {
            //       template: '<users></users>'
            //     }
            //   },
            // })
            .state("app.targets", {
                parent: "app",
                url: "/targets",
                data: {
                    roles: ["Built-in Administrator", "Administrator"],
                    docs: "targets"
                },
                views: {
                    app: {
                        template: "<targets></targets>"
                    }
                }
            });
    }

    // $locationProvider.html5Mode(true);

    // $locationProvider.html5Mode(false).hashPrefix('');

}

statesConfig.$inject = [
    "$stateProvider",
    "$urlRouterProvider",
    "$locationProvider",
    "$httpProvider",
    "config"
];

module.exports = statesConfig;




// WEBPACK FOOTER //
// ./src/azurebackup/states.config.js